import React from 'react'

function Footer() {
    return (
        <>
        <footer class="site-footer style-1 overlay-primary-light" style={{backgroundimage: 'url(images/background/bg4.webp)'}}>
            
            <div class="footer-top">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-4 col-sm-4 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s">
                            <div class="widget widget_about me-2">
                                <div class="footer-logo logo-white">
                                    <a href="/"><img src="images/logo-footer.svg" alt=""/></a> 
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-md-3 col-6 wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s">
                            <div class="widget widget_services">
                                <h2 class="footer-title">Contac Center </h2>
                                <ul class="list-hover1">
                                    <li><a href="/contact-center-soluciones-inteligentes"><span>Cobranza</span></a></li>
                                    <li><a href="/contact-center-soluciones-inteligentes"><span>Atención a clientes</span></a></li>
                                    <li><a href="/contact-center-soluciones-inteligentes"><span>Encuestas</span></a></li>
                                    <li><a href="/contact-center-soluciones-inteligentes"><span>Soporte técnico</span></a></li>
                                    <li><a href="/contact-center-soluciones-inteligentes"><span>Ventas</span></a></li>
                                    <li><a href="/contact-center-soluciones-inteligentes"><span>Monitoreo telefónico</span></a></li>
                                </ul>   
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-3 col-6 wow fadeInUp" data-wow-delay="0.6s" data-wow-duration="0.8s">
                            <div class="widget widget_services">
                                <h2 class="footer-title">Consultoria</h2>
                                <ul class="list-hover1">
                                    <li><a href="/consultoría-integral"><span>Asesoría en financiamientos </span></a></li>
                                    <li><a href="/consultoría-integral"><span>Evaluaciones para adquisiciones de portafolios </span></a></li>
                                    <li><a href="/consultoría-integral"><span>Consultoria legal mercantil </span></a></li>
                                    <li><a href="/consultoría-integral"><span>Consultoria legal civil </span></a></li>
                                    <li><a href="/consultoría-integral"><span>Consultoria legal familiar  </span></a></li>
                                    <li><a href="/consultoría-integral"><span>Consultoria legal fiscal </span></a></li>
                                </ul>   
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-bottom">
                <div class="container">
                    <div class="fb-inner">
                        <div class="row">
                            <div class="col-lg-6 col-md-12 text-start"> 
                                <p class="copyright-text">© <span class="current-year">2025</span> <a href="https://dm-series.com" target="_blank">Conecta y Crece Consultores</a> Todos los derechos reservados.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </footer>
	
	    <button class="scroltop" type="button"><i class="fas fa-arrow-up"></i></button>
        </>
    )
}

export default Footer